import { BulkEditPreviewTable } from 'features/drilldown/panels/global/bulkEdit/components/BulkEditPreviewTable'
import { EntryWithEdits } from 'features/drilldown/panels/global/bulkEdit/types'
import { DrilldownFieldType } from 'features/drilldown/rolodex/ontology/ontologyTypes'
import { FC } from 'react'

interface PreviewChangesStepProps {
  entriesWithEdits: ReadonlyArray<EntryWithEdits>
  isLoadingEntries: boolean
  onValueChange: (id: string, newValue: unknown) => void
  fieldType?: DrilldownFieldType
  fieldKey?: string
}

export const PreviewChangesStep: FC<PreviewChangesStepProps> = ({
  entriesWithEdits,
  isLoadingEntries,
  onValueChange,
  fieldType,
  fieldKey,
}) => (
  <BulkEditPreviewTable
    data={entriesWithEdits}
    isLoading={isLoadingEntries}
    onValueChange={onValueChange}
    isEditable={true}
    fieldType={fieldType}
    fieldKey={fieldKey}
  />
)

export const EmptyPreviewState: FC = () => (
  <div
    style={{
      textAlign: 'center',
      padding: '3rem',
      color: '#8c8c8c',
      fontSize: '14px',
    }}>
    Complete the earlier steps to preview your changes
  </div>
)
